/*
 *
 * ****************************************************************************
 *  * Copyright (C) 2019 Testsigma Inc.
 *  * All rights reserved.
 *  ****************************************************************************
 *
 */

import { Deserializable } from '@models/deserializable';
import { deserialize, primitive, serializable } from 'serializr';
import { SystemOsType } from '../enums/system-os-type.enum';

export class SystemInfo implements Deserializable {
  @serializable(primitive())
  uniqueId: string;
  @serializable(primitive())
  enabled: boolean;
  @serializable(primitive())
  visibleToAll: boolean;
  @serializable(primitive())
  agentVersion: string;
  @serializable(primitive())
  hostName: string;
  @serializable(primitive())
  osVersion: string;
  @serializable(primitive())
  os: number;
  @serializable
  isRegistered: boolean;
  @serializable
  isInstaller: boolean;
  @serializable
  customBuild: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SystemInfo, input));
  }

  get osType() {
    if (this.os == 2) {
      return SystemOsType.WINDOWS;
    } else if (this.os == 3) {
      return SystemOsType.MACOSX;
    } else if (this.os == 4) {
      return SystemOsType.LINUX;
    }
    return '';
  }
}
